import { render, staticRenderFns } from "./PubManagementSystem.vue?vue&type=template&id=6d74956c&scoped=true"
import script from "./PubManagementSystem.vue?vue&type=script&lang=js"
export * from "./PubManagementSystem.vue?vue&type=script&lang=js"
import style0 from "./PubManagementSystem.vue?vue&type=style&index=0&id=6d74956c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d74956c",
  null
  
)

export default component.exports